import { getBaseStyleObjectFromStyleConfig } from '@frontend/components/src/theme/styleConfigHelpers';

import { TEXT_STYLE_CONFIG } from '../text/textStyleConfig';
import type { HeadingStyleConfig } from './types';

// Heading behaves exactly like text, but defaults to a large, heavy font.
const baseStyle: HeadingStyleConfig['baseStyle'] = ({ theme, colorMode }) => {
  const textBaseStyles = getBaseStyleObjectFromStyleConfig(TEXT_STYLE_CONFIG, {
    theme,
    colorMode,
  });

  return { ...textBaseStyles, fontWeight: 'heavy' };
};

const defaultProps = {
  ...TEXT_STYLE_CONFIG.defaultProps,
  size: '3xl',
} as const;

export const HEADING_STYLE_CONFIG: HeadingStyleConfig = {
  ...TEXT_STYLE_CONFIG,
  baseStyle,
  defaultProps,
};
